import React from 'react'
import checkout_ad from './images/checkout_ad.jpg'
import './Checkout.css'
import Subtotal from './Subtotal'
import { useStatevalue } from './StateProvider'
import CheckoutProduct from './CheckoutProduct'

function Checkout() {

  const [{basket, user} , dispatch ] = useStatevalue();
  console.log(basket)

  return (
    <div className='checkout'>
      <div className='checkout_left'>
        <img
          className='checkout_ad'
          src={ checkout_ad }
          alt='Checkout ad'
          />

        <div>
          <h3>Hello, { user?.email }</h3>
          <h2 className='checkout_title'>
            Your Shopping Basket
          </h2>
          {
            basket.map(item => (
              <CheckoutProduct 
                id= { item.id }
                title= { item.title }
                image = { item.image }
                price = { item.price }
                rating = { item.rating }
                />
              ))
          }
        </div>
      </div>

      <div className='checkout_right'>
        <Subtotal />
      </div>

    </div>
  )
}

export default Checkout